import React from 'react'
import images from '../../../../app/utlis/image';
import HEALTHICON from '../../../../app/assets/images/health-feature-icon.png'

const HealthFeatureBox = () => {
    return (
        <div className='bg-darkGreyPrimary flex flex-col md:flex-row items-center justify-center px-4 md:px-24 py-6 md:py-10 relative w-full'>
            <div className='bg-yellow text-black px-4 md:px-6 py-4 md:py-6 pr-4 md:pr-12 h-fit z-10 w-full md:w-[35%]'>
                <div className='text-2xl md:text-4xl font-bold mb-2 md:mb-4 leading-snug'>Key Features of our 
                    healthcare Apps</div>
                <div className='text-base md:text-xl leading-6 md:leading-8'>Our healthcare apps aim to boost 
                    patient results, streamline processes, 
                    and provide safe, compliant 
                    healthcare services. Important
                    features include:</div>
            </div>
            <div className='relative w-full md:w-auto mt-4 md:mt-0'>
                <img src={images.HEALTHAPPFEATURE} className='w-full md:w-[90%] h-auto md:h-[50%] md:-ml-8 z-0' />
                <div className='absolute z-20 top-[20%] -left-[13%] hidden md:block'><img src={HEALTHICON} className='w-8/12'/></div>
            </div>
        </div>
    )
}

export default HealthFeatureBox
